export class NameValueDTO {
  value: number;
  name: string;
}

export function CreateNameValueDTO(value: number, name: string): NameValueDTO {
  const nameValueDTO = new NameValueDTO();
  nameValueDTO.value = value;
  nameValueDTO.name = name;
  return nameValueDTO;
}
